function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M188.651 269.888C158.955 269.888 134.869 293.973 134.869 323.669V458.197C134.869 487.893 158.955 511.978 188.651 511.978C218.347 511.978 242.432 487.893 242.432 458.197V323.669C242.411 293.973 218.325 269.888 188.651 269.888Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.405334 323.67C0.405334 353.387 24.512 377.494 54.2293 377.494C83.9467 377.494 108.053 353.387 108.053 323.67V269.846H54.272C54.2507 269.846 54.2507 269.846 54.2293 269.846C24.512 269.846 0.405334 293.952 0.405334 323.67V323.67Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M188.715 -0.0214844C188.693 -0.0214844 188.672 -0.0214844 188.651 -0.0214844C158.933 -0.0214844 134.827 24.0852 134.827 53.8025C134.827 83.5199 158.933 107.627 188.651 107.627H242.432C242.432 77.0985 242.432 84.5225 242.432 53.6958C242.411 24.0212 218.368 -0.0214844 188.715 -0.0214844V-0.0214844Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.8667 242.56H188.651C218.368 242.56 242.475 218.453 242.475 188.736C242.475 159.019 218.368 134.912 188.651 134.912H53.8667C24.1493 134.912 0.0426636 159.019 0.0426636 188.736C0.0426636 218.453 24.1493 242.56 53.8667 242.56V242.56Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M457.749 134.891C428.075 134.891 404.032 158.933 404.032 188.608V188.715V242.539H457.813C487.531 242.539 511.637 218.432 511.637 188.715C511.637 158.997 487.531 134.891 457.813 134.891C457.792 134.891 457.771 134.891 457.749 134.891V134.891Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M269.675 53.8028V188.736C269.675 218.432 293.76 242.517 323.456 242.517C353.152 242.517 377.237 218.432 377.237 188.736V53.8028C377.237 24.1068 353.152 0.0214844 323.456 0.0214844C293.76 0.0214844 269.675 24.1068 269.675 53.8028V53.8028Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.216 458.154C377.216 428.458 353.131 404.373 323.435 404.373H269.653V458.197C269.675 487.872 293.739 511.936 323.435 511.936C353.131 511.936 377.216 487.85 377.216 458.154Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M458.219 269.846H323.435C293.717 269.846 269.611 293.952 269.611 323.67C269.611 353.387 293.717 377.494 323.435 377.494H458.219C487.936 377.494 512.043 353.387 512.043 323.67C512.043 293.952 487.936 269.846 458.219 269.846V269.846Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 512,
  height: 512,
  fill: "white"
})));

var SvgSlack = function SvgSlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/slack.aefe3819.svg";
export { ForwardRef as ReactComponent };